import React from "react";
import PropTypes from "prop-types";
import { dummyCategory } from "../../consts/categories";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, setOverLay, l } from "../../functions";
import Icon from "../../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

function mapStateToProps(state) {
  return {
    settings: state.rootReducer?.appearanceSettings || {},
  };
}

class CategoryDescription extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }

  _initDescription = (preview) => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col
            xs={12}
            className="fullcol"
            style={cssSettingsText}
            dangerouslySetInnerHTML={{ __html: dummyCategory.description }}
          ></Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initDescription(true)}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initDescription()}
      </Draggable>
    );
  }
}

CategoryDescription.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(CategoryDescription);
